<template>
    <div class="contact-page padding">
        <div class="top-page">
            <h1 class="page-title" :style="$highlightColor">{{page.form_title}}</h1>
        </div>
        <div>
            <base-input id="name" type="text" label="Name" icon="user" v-model="name"
                        :errors="nameValidationErrors"
                        :placeholder="page.placeholders.name"
                        :label-style="$mainPrimaryTextStyle"></base-input>
            <base-input id="email" type="text" label="Email"
                        :placeholder="page.placeholders.email"
                        icon="paper-plane"
                        v-model="email" :errors="emailValidationErrors"
                        :label-style="$mainPrimaryTextStyle"></base-input>
            <base-input id="phone"
                        type="tel" label="Phone"
                        :placeholder="page.placeholders.phone" icon="mobile-alt"
                        v-model="phone"
                        :label-style="$mainPrimaryTextStyle"></base-input>
            <base-input id="message" type="textarea" label="Message"
                        :placeholder="page.placeholders.message"
                        v-model="message"
                        :errors="messageValidationErrors"
                        :label-style="$mainPrimaryTextStyle"></base-input>
            <button class="login-button btn btn-block btn-login"
                    @click="onSubmit"
                    :disabled="sending"
                    :style="$mainButtonStyle">
                <!--  <font-awesome-icon v-if="loading.login" :icon="['far', 'spinner-third']" spin></font-awesome-icon>-->
                <span v-if="sending">
                    <font-awesome-icon :icon="['far', 'spinner-third']" spin></font-awesome-icon>
                    <span>SENDING...</span>
               </span>
                <span v-else>SEND</span>
            </button>
        </div>
    </div>
</template>

<script>
    import BaseInput from "../base/base-input.vue";
    import Configure from './../../mixins/configure';
    import Page from './../../mixins/page.vue'

    export default {
        name: 'Contact',
        props: ['pageId'],
        mixins: [Configure, Page],
        components: {
            BaseInput
        },
        data() {
            return {
                token: null,
                name: '',
                email: '',
                phone: '',
                message: '',
                nameValidationErrors: null,
                emailValidationErrors: null,
                messageValidationErrors: null,
                sending: false,
            }
        },
        created() {
            this.token = this.$store.state.csrfToken;
        },
        computed: {
            showNameLabel() {
                return this.name.length > 0;
            }
        },
        methods: {
            onSubmit() {
                const validated = this.validate();

                // Send if no validation errors
                if (validated) {
                    this.send();
                }
            },
            validate() {
                // Name
                this.nameValidationErrors = this.name ? null : ['A name is required'];

                // Email
                if (this.email) {
                    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    this.emailValidationErrors = regex.test(this.email) ? null : ['Your Email must be a valid email address'];
                } else {
                    this.emailValidationErrors = ['An email is required'];
                }

                // Message
                this.messageValidationErrors = this.message ? null : ['A message is required'];

                return !(this.nameValidationErrors || this.emailValidationErrors || this.messageValidationErrors);
            },
            send() {
                let data = {
                    producerId: ab.user.id,
                    name: this.name,
                    email: this.email,
                    phone: this.phone,
                    message: this.message,
                };
                this.sending = true;
                this.$http.post(this.getContactUrl(), data)
                    .then((response) => {
                        this.$router.push('/');
                        swal({
                            title: "Success",
                            text: "Your message has been sent!",
                            icon: "success",
                            buttons: false,
                            timer: 2000,
                        });
                        this.reset();
                    })
                    .catch((error) => {
                        const message = error.response.data.error.message;
                        swal("Failed", "Oops something went wrong, please try again.", "warning");
                    })
                    .finally(() => {
                        this.sending = false;
                    });
            },
            reset() {
                this.name = '';
                this.email = '';
                this.phone = '';
                this.message = '';
            },
            getContactUrl() {
                return this.$store.state.domainUrlBuilder.buildFromOrigin(`/contact`)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .page-title {
        text-align: center;
        margin-top: 3rem;
        margin-bottom: 3rem;
        font-family: Poppins;
        color: #87499d;
    }

    .btn-login {
        background-color: #87499d;
        letter-spacing: 0.1rem;
        font-size: 12px;
        margin-top: 2.5rem;
        padding: 15px 70px;
        color: #fff;
    }

</style>
